module.exports = __webpack_public_path__ + "img/4.9e5f5a3f.jpg";